import Edit from './components/Edit';
import View from './components/View';
import AlignWidget from './components/Widgets/AlignWidget';
import circleMenuSVG from '@plone/volto/icons/content-existing.svg';
import './theme/main.less';

const applyConfig = (config) => {
  config.widgets.widget.inner_align = AlignWidget;
  config.blocks.blocksConfig.__button = {
    id: '__button',
    title: 'Spendenformular',
    icon: circleMenuSVG,
    group: 'common',
    view: View,
    edit: Edit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };
  return config;
};

export default applyConfig;
